/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4.167C4.5 3.536 5.03 3 5.714 3H11v3.667a.5.5 0 00.5.5h4v8.666c0 .632-.53 1.167-1.214 1.167H5.714C5.03 17 4.5 16.465 4.5 15.833V4.167zm10.268 2L12 3.475v2.692h2.768zM11.5 2h.214a.5.5 0 01.349.142l4.286 4.166a.5.5 0 01.151.359v9.166c0 1.21-1.005 2.167-2.214 2.167H5.714c-1.21 0-2.214-.957-2.214-2.167V4.167C3.5 2.957 4.505 2 5.714 2H11.5z" _fill="#1F222C"/>'
  }
})
